import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/styles/btn-styles.css';
import '../src/assets/styles/form-styles.css';
import '../src/assets/styles/table-styles.css';
import '../src/assets/styles/modal-styles.css';
import '../src/assets/styles/file-upload-styles.css';
import reportWebVitals from './reportWebVitals';
import UserLayout from './layouts/UserLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Login from './pages/Login/Login';
import PrivateRoute from './routes/PrivateRoute';
import RedirectRoute from './routes/RedirectRoute';
import { ToastContainer } from 'react-toastify';
import VerificationLayout from './layouts/VerificationLayout';
import ExamControllerLayout from './layouts/ExamControllerLayout';
import ExamControllerAssistantLayout from './layouts/ExamControllerAssistantLayout';
import NormalUserLayout from './layouts/NormalUserLayout';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/certificates",
                  exam_controller: "/controller/certificates",
                  exam_controller_assistant: "/assistant/certificates",                 
                  user: "/user/certificates",
                }}
              >
                <Login />
              </RedirectRoute>
            }
          />
          <Route
            path="*"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/certificates",
                  exam_controller: "/controller/certificates",
                  exam_controller_assistant: "/assistant/certificates",                 
                  user: "/user/certificates",
                }}
              >
                <Navigate to="/login" />
              </RedirectRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                roleRedirects={{
                  admin: "/admin/certificates",                  
                  exam_controller: "/controller/certificates",
                  exam_controller_assistant: "/assistant/certificates",                 
                  user: "/user/certificates",
                }}
              >
                <UserLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/controller/*"
            element={
              <PrivateRoute
                allowedRoles={["exam_controller"]}
                roleRedirects={{
                  admin: "/admin/certificates",                  
                  exam_controller: "/controller/certificates",
                  exam_controller_assistant: "/assistant/certificates",                 
                  user: "/user/certificates",
                }}
              >
                <ExamControllerLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/assistant/*"
            element={
              <PrivateRoute
                allowedRoles={["exam_controller_assistant"]}
                roleRedirects={{
                  admin: "/admin/certificates",                  
                  exam_controller: "/controller/certificates", 
                  exam_controller_assistant: "/assistant/certificates",                 
                  user: "/user/certificates",
                }}
              >
                <ExamControllerAssistantLayout />
              </PrivateRoute>
            }
          />
          <Route
            path="/user/*"
            element={
              <PrivateRoute
                allowedRoles={["user"]}
                roleRedirects={{
                  admin: "/admin/certificates",                  
                  exam_controller: "/controller/certificates", 
                  exam_controller_assistant: "/assistant/certificates",                  
                  user: "/user/certificates",
                }}
              >
                <NormalUserLayout />
              </PrivateRoute>
            }
          />
          <Route
            path="/document_ref/:document_ref"
            element={
              <VerificationLayout />
            }
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
